import { jsx as _jsx } from "react/jsx-runtime";
import { Block, BlockVariant, BlockRow, BlockGrid, BlockSpan, BlockContentAligh, BlockSize, GridType, } from './SimpleBlocks';
export function renderBlock(component, index, renderContentFunction) {
    function mapVariant(variant) {
        switch (variant) {
            case 'left':
                return BlockVariant.Left;
            case 'right':
                return BlockVariant.Right;
            case 'empty':
                return BlockVariant.Empty;
            case 'nested':
                return BlockVariant.Nested;
            default:
                return undefined;
        }
    }
    function mapContentAlign(contentAlign) {
        switch (contentAlign) {
            case 'left':
                return BlockContentAligh.Left;
            case 'center':
                return BlockContentAligh.Center;
            case 'right':
                return BlockContentAligh.Right;
            default:
                return undefined;
        }
    }
    function mapSize(size) {
        switch (size) {
            case 'full':
                return BlockSize.Full;
            default:
                return undefined;
        }
    }
    function mapSpan(span) {
        switch (span) {
            case 'rows':
                return BlockSpan.AllRows;
            case 'columns':
                return BlockSpan.AllColumns;
            default:
                return undefined;
        }
    }
    const variant = mapVariant(component.properties.variant);
    const span = mapSpan(component.properties.span);
    const contentAlign = mapContentAlign(component.properties.align);
    const size = mapSize(component.properties.size);
    return (_jsx(Block, { variant: variant, span: span, contentAlign: contentAlign, size: size, children: renderContentFunction && renderContentFunction(component) }));
}
export function renderBlockRow(component, index, renderContentFunction) {
    return _jsx(BlockRow, { children: renderContentFunction && renderContentFunction(component) });
}
export function renderBlockGrid(component, index, renderContentFunction) {
    function mapGridType(type) {
        switch (type) {
            case 'properties':
                return GridType.Properties;
            default:
                return undefined;
        }
    }
    const type = mapGridType(component.properties.type);
    return (_jsx(BlockGrid, { type: type, children: renderContentFunction && renderContentFunction(component) }));
}
